export default "__VITE_ASSET__DEKfMrjH__"